import React from 'react';


function Basket(props) {
  const { cartItems, onAdd, onRemove } = props;
  const itemsPrice = cartItems.reduce((a, c) => a + c.qty * c.price, 0);
  const taxPrice = itemsPrice * 0.14;
  const shippingPrice = itemsPrice > 2000 ? 0 : 20;
  const totalPrice = itemsPrice + taxPrice + shippingPrice;
  return (
    <aside className="block col1 cart">
      <h2 className='cartTitle'>Cart Items</h2>
      <div>
        {cartItems.length === 0 && <div className='emptyCart'>Cart is empty</div>}
        {cartItems.map((item) => (
          <div key={item.id} className="row">
            <div className="col2">{item.name}</div>
            <div className="col2">
              <button onClick={() => onRemove(item)} className="remove">
                -
              </button>{' '}
              <button onClick={() => onAdd(item)} className="add">
                +
              </button>
            </div>

            <div className="col2 text-right">
              {item.qty} x ${item.price.toFixed(2)}
            </div>
          </div>
        ))}

        {cartItems.length !== 0 && (
          <>
            <hr></hr>
            <div className="row">
              <div className="col2">Items Price</div>
              <div className="col1 text-right">${itemsPrice.toFixed(2)}</div>
            </div>
           
            <div className="row">
              <div className="col2">Shipping Price</div>
              <div className="col1 text-right">
                ${shippingPrice.toFixed(2)}
              </div>
            </div>

            <div className="row">
              <div className="col2">
                <strong>Total Price</strong>
              </div>
              <div className="col1 text-right">
                <strong>${totalPrice.toFixed(2)}</strong>
              </div>
            </div>
            <hr />
            <div className="row">
              <button onClick={() => alert('We Got Your Order, Your Delivery Is On The Way')}>
                Order
              </button>
            </div>
          </>
        )}
      </div>
    </aside>
  );
}
export default Basket;
